import { ReactElement, ReactNode, useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  ModalProps,
} from "@chakra-ui/react";

export type RenderContentProps = {
  formId: string;
  onClose: () => void;
  setIsLoading: (isLoading: boolean) => void;
};

type Props = Pick<ModalProps, "size" | "isOpen" | "onClose"> & {
  formId?: string;
  isDisabled?: boolean;
  label: ReactNode;
  renderContent: (props: RenderContentProps) => ReactElement;
  submitLabel?: ReactNode;
};

export default function MergeModal({
  formId = "merge-modal-form",
  isDisabled,
  isOpen,
  label,
  onClose,
  renderContent,
  size = "xl",
  submitLabel = "Merge",
}: Props) {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(false);
  }, [isOpen, isDisabled]);

  return (
    <Modal isOpen={!isDisabled && isOpen} onClose={onClose} size={size}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{label}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {renderContent?.({ formId, onClose, setIsLoading })}
        </ModalBody>

        <ModalFooter>
          <Button onClick={onClose} variant="ghost" mr={2}>
            Cancel
          </Button>
          <Button
            type="submit"
            form={formId}
            colorScheme="pinkButton"
            isLoading={isLoading}
          >
            {submitLabel}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
